import { render } from "./BoxTitleData.vue?vue&type=template&id=50d297b8"
import script from "./BoxTitleData.vue?vue&type=script&setup=true&lang=js"
export * from "./BoxTitleData.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Sources/JavaScript/Extensions/Lfmpublications/Vue/components/BoxTitleData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50d297b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50d297b8', __exports__)) {
    api.reload('50d297b8', __exports__)
  }
  
  module.hot.accept("./BoxTitleData.vue?vue&type=template&id=50d297b8", () => {
    api.rerender('50d297b8', render)
  })

}


export default __exports__